// extracted by extract-css-chunks-webpack-plugin
module.exports = {"boxItemsContainer":"_2gsJAd","boxLink":"_1WKwHq","boxItem":"_3R6JUB","boxIcon":"_202ZKX","boxTitle":"_3VcDeL"};